import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M333-186q-33 0-56-23t-23-57v-429q0-33 23-57 23-23 56-23h184q71 0 121 46 49 46 49 111 0 34-19 69t-60 54v7q51 17 75 57 23 41 23 81 0 63-51 114-51 50-132 50H333Zm21-84h155q29 0 62-22 32-22 32-67 0-44-32-66-32-23-61-23H354v178Zm0-258h148q31 0 58-23 28-23 28-59 0-34-27-58-26-25-60-25H354v165Z"/>',
  f: '<path d="M333-186q-33 0-56-23t-23-57v-429q0-33 23-57 23-23 56-23h184q71 0 121 46 49 46 49 111 0 34-19 69t-60 54v7q51 17 75 57 23 41 23 81 0 63-51 114-51 50-132 50H333Zm21-84h155q29 0 62-22 32-22 32-67 0-44-32-66-32-23-61-23H354v178Zm0-258h148q31 0 58-23 28-23 28-59 0-34-27-58-26-25-60-25H354v165Z"/>',
};

export default data;
